import { h } from 'preact';

export default function ChevronRight(props: React.ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={32}
      height={32}
      viewBox="0 0 32 32"
      {...props}
    >
      <path
        d="M11.29 25.29a1 1 0 101.41 1.41l10-10a1 1 0 000-1.41l-10-10a1 1 0 10-1.41 1.41l9.3 9.3-9.3 9.29z"
      />
    </svg>
  );
}

